import { render, staticRenderFns } from "./Spa.vue?vue&type=template&id=70fab282&scoped=true&"
import script from "./Spa.vue?vue&type=script&lang=ts&"
export * from "./Spa.vue?vue&type=script&lang=ts&"
import style0 from "./Spa.vue?vue&type=style&index=0&id=70fab282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fab282",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VContainer,VFlex,VLayout})
